import { render, staticRenderFns } from "./tile-orders.vue?vue&type=template&id=92796c7c&"
import script from "./tile-orders.vue?vue&type=script&lang=js&"
export * from "./tile-orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports